var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 offset-md-3"},[_c('div',{staticClass:"alert pl-5"},[_c('div',{staticClass:"fs-1"},[_vm._v(" \"You don't need "),_c('strong',[_vm._v("Fundamental")]),_vm._v(". "),_c('br'),_vm._v(" Just "),_c('strong',[_vm._v("Prompt it")]),_vm._v(", damn it!\" ")])])])])])
}]

export { render, staticRenderFns }